import { useEffect, useState } from 'react'
import { BackToHomeBtn, FormSubmitBtn, FormTitle, GreatNonProfitsImg, LoginForm, LoginLeftPart, LoginRightPart, LoginSection, UserCreateTitle } from './loginStyle'
import { MESSAGE } from '../../utils/message'
import Great_Non_Profits_Img from "../../assests/images/ls-page-image/great-nonprofits-img.svg";
import Left_arrow_icon from "../../assests/images/arrow-down.svg";
import { Container, Row, Col, Image, Button, Form, InputGroup } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { REGEX } from '../../utils/constant'
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { LoginProps } from '../../utils/types';
import Key_not_slash_icon from "../../assests/images/ls-page-image/key-not-slash.svg";
import Key_slash_icon from "../../assests/images/ls-page-image/key-slash.svg";
import AuthLogoCard from '../../components/common/authLogoCard';
import { resetPasswordAction, resetPasswordHandler } from '../../redux/slices/auth/resetPassword-slice';

const ResetPassword = () => {
    const navigate: any = useNavigate();
    const dispatch: any = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const resetPassword = useSelector((state: any) => state?.resetPassword)
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    useEffect(() => {
        if (resetPassword?.data) {
            if (resetPassword?.data?.status === 200 || resetPassword?.data?.status === 201 || resetPassword?.data?.status === 202) {
                resetPasswordAction.resetPasswordSliceReset()
                navigate("/signin");
            }
        }
    }, [resetPassword])

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    console.log();
    
    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleResetPassword = async (values: LoginProps) => {
        const reqBody = {
            ...values,
            token: token
        }
        await dispatch(resetPasswordHandler(reqBody));
    }

    const formik = useFormik({
        initialValues: {
            confirm_password: '',
            password: ''
        },
        validationSchema: Yup.object({
            password: Yup.string().trim()
                .required(MESSAGE.requiredErrors(MESSAGE.passwordLabel))
                .matches(
                    REGEX.passwordValidate,
                    MESSAGE.passwordValidation
                ),
            confirm_password: Yup.string().trim()
                .required(MESSAGE.requiredErrors(MESSAGE.confirmPasswordLabel))
                .oneOf([Yup.ref('password')], MESSAGE.passwordInvalidErrors(MESSAGE.confirmPasswordLabel))
                .matches(REGEX.passwordValidate, MESSAGE.passwordInvalidErrors(MESSAGE.confirmPasswordLabel))
        }),
        onSubmit: (values: LoginProps, { resetForm }) => {
            handleResetPassword(values)
            resetForm({});
        },
    });
    return (
        <LoginSection>
            <Container fluid>
                <Row>
                    <LoginLeftPart as={Col} sm={12} md={6} lg={6}>
                        <AuthLogoCard userType="AuthUser" />
                    </LoginLeftPart>
                    <LoginRightPart as={Col} md={6} sm={12} lg={6}>
                        <BackToHomeBtn>
                            <Button onClick={() => navigate("/")} className="back-btn"><Image src={Left_arrow_icon} alt="Back Arrow" width="5px" height="12px" />{MESSAGE.backToWebsite}</Button>
                        </BackToHomeBtn>
                        <GreatNonProfitsImg>
                            <Image src={Great_Non_Profits_Img} alt="Brand Logo" width="324px" height="24px" />
                        </GreatNonProfitsImg>

                        {location.pathname === "/reset" && <>
                            <UserCreateTitle className="user-password-reset-title">
                                <FormTitle className="pass-reset-password">{MESSAGE.passwordResetFormTitle}</FormTitle>
                            </UserCreateTitle>

                            <LoginForm className="password-reset-wrapper">
                                <Form className="login-form" onSubmit={formik.handleSubmit}>

                                    <Form.Group controlId="formBasicPassword" className="form-group">
                                        <InputGroup>
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="New password"
                                                id="password"
                                                maxLength={30}
                                                name="password"
                                                value={formik.values.password}
                                                onChange={formik.handleChange}
                                            />
                                            <InputGroup.Text onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }} >
                                                <Image src={showPassword ? Key_slash_icon : Key_not_slash_icon} alt="Toggle Password Visibility" width="24px" height="24px" />
                                            </InputGroup.Text>
                                        </InputGroup>
                                        {formik.touched.password && formik.errors.password && (
                                            <div className="error">
                                                <p>{formik.errors.password}</p>
                                            </div>
                                        )}
                                    </Form.Group>

                                    <Form.Group controlId="formBasicPassword" className="form-group">
                                        <InputGroup>
                                            <Form.Control
                                                type={showConfirmPassword ? 'text' : 'password'}
                                                placeholder="Confirm password"
                                                id="confirm_password"
                                                maxLength={30}
                                                name="confirm_password"
                                                value={formik.values.confirm_password}
                                                onChange={formik.handleChange}
                                            />
                                            <InputGroup.Text onClick={toggleConfirmPasswordVisibility} style={{ cursor: 'pointer' }} >
                                                <Image src={showConfirmPassword ? Key_slash_icon : Key_not_slash_icon} alt="Toggle Password Visibility" width="24px" height="24px" />
                                            </InputGroup.Text>
                                        </InputGroup>
                                        {formik.touched.confirm_password && formik.errors.confirm_password && (
                                            <div className="error">
                                                <p>{formik.errors.confirm_password}</p>
                                            </div>
                                        )}
                                    </Form.Group>

                                    <FormSubmitBtn>
                                        <Button variant="primary" type="submit" className="btn-outline-success-blue"> {MESSAGE.submitBtn}
                                            {resetPassword?.isLoading && <span className="btnloader"></span>}
                                        </Button>
                                    </FormSubmitBtn>
                                </Form>
                            </LoginForm>
                        </>}


                    </LoginRightPart>
                </Row>
            </Container>
        </LoginSection>
    )
}

export default ResetPassword
